import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';

import {
  menuHeader,
  menuHeaderUDC
} from '../../../constants/menuHeader';

import classes from './MenuHeader.module.css';

const MenuHeader = props => {
  const url = window.location.pathname.split('/');
  const { t } = useTranslation(['header']);
  const [itemSelected, setItemSelected] = useState('');

  useEffect(() => {
    if (url[1] === 'campus') {
      setItemSelected('studentCampus');
    } else if (url[1] === 'store') {
      setItemSelected('eduStore');
    } else if (url[1] === 'createAcademy') {
      setItemSelected('teachWithMayahii');
    } else if (url[1] === 'aboutme') {
      setItemSelected('about');
    }
  }, [url]);

  const changeOptionHandler = option => () => {
    setItemSelected(option);
  };

  return (
    <div
      className={
        props.udcHost
          ? classes.menuHeaderContainerUDC
          : classes.menuHeaderContainer
      }
    >
      {props.udcHost
        ? menuHeaderUDC.map(item => (
            <Button
              key={item.link}
              variant="text"
              component={Link}
              to={item.link}
              onClick={changeOptionHandler(item.text)}
              className={
                itemSelected === item.text
                  ? classes.itemSelected
                  : classes.item
              }
            >
              {t(item.text)}
            </Button>
          ))
        : menuHeader.map(item => {
            return item.externalLink ? (
              <Button
                key={item.link}
                variant="text"
                component="a"
                href={item.link}
                className={classes.item}
              >
                {t(item.text)}
              </Button>
            ) : (
              <Button
                key={item.link}
                variant="text"
                component={Link}
                to={item.link}
                onClick={changeOptionHandler(item.text)}
                className={
                  itemSelected === item.text
                    ? classes.itemSelected
                    : classes.item
                }
              >
                {t(item.text)}
              </Button>
            );
          })}
    </div>
  );
};

MenuHeader.propTypes = {
  // eslint-disable-next-line react/require-default-props
  udcHost: PropTypes.bool
};

export default MenuHeader;
